import Access from 'ui/Access';
import PageTabs from 'ui/PageTabs';
import React from 'react';
import { SubscriptionContext } from './SubscriptionContext';
import { TAB_LIST } from './utils/consts';
import { flowRight } from 'lodash/fp';
import { loadSubscription } from './Services';
import { withAppContext } from '../AppContext';
import { withSnackbar } from 'notistack';

class SubscriptionDetail extends React.Component {
    state = {
        subscription: {},
        tabs: [],
        tab: -1,
    };
    _name = 'Subscriptions';

    componentDidMount() {
        const { state } = this.props.location;
        if (state && state.subscription) {
            const tabs = this.updateTabs(false);
            return this.setState(
                {
                    subscription: state.subscription,
                    tabs,
                },
                () => {
                    this.updateHeader(state.subscription);
                }
            );
        }

        this.props.updateBreadcrumbs([this._name]);
        this.loadInfo();
    }

    componentDidUpdate(oldProps) {
        this.loadTabs(oldProps);
    }

    updateHeader = subscription => {
        this.props.updateBreadcrumbs([
            { name: this._name, path: '/subscriptions' },
            this.getSubscriptionName(subscription),
        ]);
    };

    loadTabs = oldProps => {
        const { tab } = this.props;
        if (oldProps.tab !== tab || tab !== this.state.tab) {
            this.setState({ tab });
        }
    };

    loadInfo = () => {
        const { app } = this.props;
        loadSubscription(app.currentUser.subscription_uuid)
            .then((response = []) => {
                const [subscription] = response;
                this.updateHeader(subscription);
                this.setState({ subscription, loading: false });
                this.updateTabs(true);
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    };

    getSubscriptionName = subscription => {
        const { subscription_level } = subscription;
        if (!subscription_level) return '';
        return subscription_level.user_display_name ?? '';
    };

    updateTabs(saveInState) {
        const { app } = this.props;
        const accessFilter = tab => app.canView(tab.access);
        const tabs = TAB_LIST.filter(accessFilter);
        if (saveInState) {
            this.setState({ tabs });
        }
        return tabs;
    }

    findTab(num) {
        const { tabs } = this.state;
        return tabs[num] || tabs[0];
    }

    hasTab(name) {
        const { tabs } = this.state;
        return tabs.some(tab => tab.name === name);
    }

    findTabUrl(name) {
        const { subscription } = this.state;
        if (this.hasTab(name)) {
            return `/subscriptions/${subscription.uuid}/${name}`;
        }
        return '';
    }

    canChangeTab(tabAccess, subscription) {
        const { app } = this.props;
        if (Array.isArray(tabAccess)) {
            return tabAccess.some(access => app.canChange(access));
        }
        return app.canChange(tabAccess);
    }

    onTabChange = tab => {
        const { subscription } = this.state;
        if (tab !== this.props.tab) {
            this.setState({ tab });
            if (this.hasTab(tab)) {
                this.props.history.push(this.findTabUrl(tab), { subscription });
            }
        }
    };

    render() {
        const { tabs, subscription, tab } = this.state;
        const { app, history, updateBreadcrumbs } = this.props;
        if (tab === -1) {
            return null;
        }
        return (
            <PageTabs
                tabs={tabs}
                current={tab}
                onChange={this.onTabChange}
                darkBackground={[3]}
            >
                {() => {
                    const currentTab = this.findTab(tab);
                    if (!currentTab) return null;
                    const editable =
                        currentTab && currentTab.editable
                            ? currentTab.editable(app.currentUser, subscription)
                            : true;
                    const ComponentTab = currentTab.component;
                    return (
                        <SubscriptionContext.Provider
                            value={SubscriptionContext.create(
                                subscription.uuid,
                                this.state.subscription
                            )}
                        >
                            <ComponentTab
                                id={subscription.uuid}
                                tab={this.props.tab}
                                history={history}
                                subscription={subscription}
                                updateBreadcrumbs={updateBreadcrumbs}
                                editable={
                                    this.canChangeTab(
                                        currentTab.access,
                                        subscription
                                    ) && editable
                                }
                                usersAccess={app.canView(
                                    Access.SUBSCRIPTION_USERS
                                )}
                                onMessage={this.props.enqueueSnackbar}
                            />
                        </SubscriptionContext.Provider>
                    );
                }}
            </PageTabs>
        );
    }
}

export default flowRight(withSnackbar, withAppContext)(SubscriptionDetail);
